(ns dashboard.components.confirm-modal
  (:require [re-frame.core :as rf]
            [dashboard.ui :as ui]))

(def texts {:button {:confirm "Confirm"
                     :cancel  "Cancel"}})

(defn confirm-modal [{:keys [title
                             disable-confirm
                             content
                             on-confirm
                             label-cancel
                             label-confirm
                             invert-button-colors?
                             notification-classes]
                      :or   {label-cancel          (-> texts :button :cancel)
                             label-confirm         (-> texts :button :confirm)
                             invert-button-colors? false}}
                     {:keys [on-close ctx]}]
  [:div.card.is-clipped
   [:div.card-header {:class notification-classes}
    [:p.card-header-title {:class notification-classes} title]
    [:button.card-header-icon.is-inverted {:on-click #(rf/dispatch [::ui/pop-modal])}
     [:span.icon [:i.fas.fa-xmark]]]]
   [:div.card-content
    [content ctx]]
   [:div.card-footer
    [:button.button.is-inverted.card-footer-item
       {:class    [(if invert-button-colors? "is-info" "is-danger")]
        :on-click on-close} label-cancel]
    [:button.button.is-inverted.card-footer-item
     {:class    [(if invert-button-colors? "is-danger" "is-info")]
      :disabled (when disable-confirm
                  (disable-confirm ctx))
      :on-click (fn []
                  (on-confirm ctx)
                  (on-close))}
     label-confirm]]])
